import React from "react";
import { Box, Typography, Button } from "@mui/material";
import globalStyles from "../../global";
import { useTranslation } from "react-i18next";
const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const GlobalPromise = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: "affordable_rates.svg",
      title: t("GlobalPromise.features.0"),
    },
    {
      icon: "dry-cleaning.svg",
      title: t("GlobalPromise.features.1"),
    },
    {
      icon: "taap-water.svg",
      title: t("GlobalPromise.features.2"),
    },
    {
      icon: "skin_friendly.svg",
      title: t("GlobalPromise.features.3"),
    },
  ];

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.textSection}>
          <Box sx={styles.headerSection}>
            <Typography variant="h1_gothic" sx={styles.title}>
              {t("GlobalPromise.promiseTitle")}
            </Typography>
          </Box>

          {/* <Typography variant="regular_text_ur" sx={styles.description}>
            {t("GlobalPromise.promiseContent")}
          </Typography> */}

          <Box sx={styles.promiseList}>
            {t("GlobalPromise.promisePoints", { returnObjects: true }).map(
              (promise, index) => (
                <Box key={index} sx={styles.promiseItem}>
                  <Box
                    component="img"
                    src={`${imageBaseUrl}checkmark.png`}
                    alt="Checkmark"
                    sx={{
                      width: "20px",
                      height: "20px",
                      marginRight: "8px",
                      objectFit: "contain",
                    }}
                  />
                  <Typography variant="body2" sx={styles.promiseText}>{promise}</Typography>
                </Box>
              )
            )}
          </Box>

          {/* Button added here as per reference image */}
          <Button
            variant="contained"
            sx={{
              mt: "32px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "16px",
              textTransform: "none",
              boxShadow: "none",
              padding: "12px 24px",
              width: "fit-content",
              "&:hover": {
                backgroundColor: "#388e3c",
                boxShadow: "none",
              },
            }}
          >
            Start your Journey Today!
          </Button>
        </Box>

        <Box sx={styles.imageSection}>
          <Box sx={styles.imageWrapper}>
            {/* Image */}
            <Box
              component="img"
              src={`${imageBaseUrl}previewpromise.png`}
              alt="Promise Video"
              sx={styles.mainImage}
            />

            {/* Cards inside image container at bottom-left */}
            <Box sx={styles.featuresGrid}>
              {features.map((feature, index) => (
                <Box key={index} sx={styles.featureCard}>
                  <Box
                    component="img"
                    src={`${imageBaseUrl}${feature.icon}`}
                    alt={feature.title}
                    sx={styles.featureIcon}
                  />
                  <Typography variant="body2" sx={styles.featureTitle}>
                    {feature.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainContainer: {
    width: "100%",
    padding: { xs: "26px", md: "60px 24px" },
    backgroundColor: globalStyles.colors.white,
  },
  contentWrapper: {
    maxWidth: "1300px",
    margin: "0 auto",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: "20px",
    marginBottom: "40px",
  },
  textSection: {
    flex: 1,
    paddingRight: { xs: 0, md: "40px" },
  },
  imageSection: {
    flex: 1,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: { xs: "0 12px", md: 0 },
  },

  imageWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: { xs: "320px", sm: "400px", md: "500px" },
  },

  mainImage: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
    display: "block",
  },
  featuresGrid: {
    position: { xs: "relative", md: "absolute" },
    bottom: { xs: "0", md: "-75px" },
    left: { xs: "0", md: "-150px" },
    display: "flex",
    flexDirection: "row",
    flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
    gap: "16px",
    zIndex: 2,
    paddingLeft: { xs: "0", md: "16px" },
    justifyContent: { xs: "center", md: "flex-start" },
    marginTop: { xs: "24px", sm: "32px", md: 0 }, // spacing from main image in mobile/tablet
  },

  featureCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    padding: "16px",
    width: {
      xs: "calc(50% - 8px)",  // Two cards per row with 16px total gap
      sm: "calc(50% - 8px)",  // Same for tablet
      md: "140px",            // Full fixed width for desktop
    },
    height: { xs: "auto", md: "120px" },
    borderRadius: "12px",
    border: "1px solid #eee",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },

  featureIcon: {
    width: "30px",
    height: "30px",
    marginBottom: "6px",
  },
  featureTitle: {
     fontSize: { xs: "12px", sm: "18px", md: "18px" },
    color: globalStyles.colors.text,
    textAlign: "center",
  },
  title: {
    color: globalStyles.colors.army_green,
     fontSize: { xs: "24px", sm: "38px", md: "40px" } ,
    marginBottom: "24px",
  },
  headerSection: {
    marginBottom: "16px",
  },
  description: {
    fontWeight: "500",
     fontSize: { sm: "14px", xs: "14px" , md:"22px"},
  color: globalStyles.colors.uclean_medium_gray,
  },
  promiseList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "14px"
  },
  promiseItem: {
    display: "flex",
    alignItems: "flex-start",
  },
  promiseText: {
    color: globalStyles.colors.text,
     fontSize: { xs: "12px", sm: "18px", md: "18px" },
  },
};

export default GlobalPromise;